import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setSelectedTour, setSelectedCycle } from "../store/planTourSlice";

interface BakeryNoidaModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDone?: (selectedTour: string, selectedShift: string) => void;
  isLoading?: boolean;
}

const BakeryNoidaModal: React.FC<BakeryNoidaModalProps> = ({ isOpen, onClose, onDone, isLoading }) => {
  const [selectedTour, setSelectedTourLocal] = useState("Baking & Cooling");
  const [selectedShift, setSelectedShiftLocal] = useState("Shift 1");
  const dispatch = useDispatch();
  
  if (!isOpen) return null;

  const handleDone = () => {
    console.log('BakeryNoidaModal handleDone called with:', { selectedTour, selectedShift });
    dispatch(setSelectedTour(selectedTour));
    dispatch(setSelectedCycle(selectedShift));
    try {
      sessionStorage.setItem('shiftValue', selectedShift || 'Shift 1');
    } catch (e) {
      console.warn('Unable to set shiftValue in sessionStorage', e);
    }
    console.log('Redux state updated, calling onDone callback');
    if (onDone) onDone(selectedTour, selectedShift);
  };

  return (
    <div className="fixed inset-0 bg-[rgba(0,0,0,0.66)] z-50 flex items-center justify-center">
      <div className="bg-white rounded-lg shadow-[0_12px_40px_rgba(0,0,0,0.25)] p-6 w-[90%] max-w-md">
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold text-gray-700">Start Plant Tour</h2>
          <button
            className="text-gray-500 hover:text-gray-800 text-xl font-bold leading-none"
            onClick={onClose}
            disabled={isLoading}
          >
            ×
          </button>
        </div>

        {/* Tour Select */}
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1 text-gray-700">Select Tour</label>
          <select 
            className="w-full border border-gray-300 rounded-md px-3 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500" 
            value={selectedTour} 
            onChange={e => setSelectedTourLocal(e.target.value)} 
            disabled={isLoading}
          >
            <option>Baking & Cooling</option>
            <option>Coding</option>
            <option>Mixing</option>
            <option>Process Format</option>
            <option>PQI</option>
            <option>Sieves and magnets</option>
            <option>Proofing</option>
          </select>
        </div>

        {/* Shift Select */}
        <div className="mb-6">
          <label className="block text-sm font-medium mb-1 text-gray-700">Select Shift</label>
          <select 
            className="w-full border border-gray-300 rounded-md px-3 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500" 
            value={selectedShift} 
            onChange={e => setSelectedShiftLocal(e.target.value)} 
            disabled={isLoading}
          >
            <option>Shift 1</option>
            <option>Shift 2</option>
            <option>Shift 3</option>
          </select>
        </div>

        {/* Loading Indicator */}
        {isLoading && (
          <div className="flex items-center justify-center mb-4">
            <svg className="animate-spin h-5 w-5 text-blue-600 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
            </svg>
            <span className="text-blue-600 text-sm">Generating Plan Tour ID...</span>
          </div>
        )}

        {/* Footer Buttons */}
        <div className="flex justify-end gap-2">
          <button
            className="px-4 py-2 rounded-md border border-gray-300 text-blue-600 hover:bg-gray-50 font-medium"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700 font-medium"
            onClick={handleDone}
            disabled={isLoading}
          >
            {isLoading ? "Generating..." : "Done"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BakeryNoidaModal;
